import { render, staticRenderFns } from "./TecEnfermera.vue?vue&type=template&id=0fb70cd7"
import script from "./TecEnfermera.vue?vue&type=script&lang=js"
export * from "./TecEnfermera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports